import React, {useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import { useNavigate } from 'react-router-dom';
import BreadCrumbs from '../BreadCrumbs';
import { bookhalfIcon, calendarsIcon, certiIcon, clockIcon, coursesIcon, homeIcon, emplyArrow, leftArrowLong } from "../../../constants/icons";
import IntroCard from '../card/IntroCard';
import Tab from 'olive-react-myoneui/lib/Tab';
import Nav from 'olive-react-myoneui/lib/Nav';
import Button from "olive-react-myoneui/lib/Button";
import Toast from "olive-react-myoneui/lib/Toast";
import ToastInfo from "olive-react-myoneui/lib/ToastInfo";
import ToastContainer from 'olive-react-myoneui/lib/ToastContainer';
import CourseProgressAccordion from './CourseProgressAccordion';
import CourseQandA from './CourseQandA';
import CourseReport from './CourseReport';
import TestJourney from './TestJourney';
import CourseAnnouncements from './CourseAnnouncements';
import { getCourse, getEnrolledContents, getEnrolledSubjectReport } from '../../../../api/afterLogin/courses';
import { pluralize } from '../../../../helpers/string_helper';
import { imageSrc, courseMaterialUrl, filterUrl } from '../../../../helpers/url_helper';
import { formatDaysAgo } from '../../../../helpers/datetime_helper';
import { addDays, format, parseISO } from "date-fns";
import { API_URL } from "../../../constants/config";
import { CourseContentLoader, CourseCurriculumLoader } from '../../Loader';
import { validMember, renewalEligibility, renewalCheckout } from '../../../../api/afterLogin/renewal';
import { Buffer } from 'buffer';
import Error404 from '../../../../modules/Error404';
import Error403 from '../../../../modules/Error403';
import { checkDisabledSp } from '../../../../helpers/permission_helper';

const CourseDetails = ({ className }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const adminData  = useSelector((state) => state.admin);
  const configData = useSelector((state) => state.config);
  const miscellaneous = useSelector((state) => state.user.miscellaneous);
  const learnerData = useSelector((state) => state.user.user);
  const paths = useSelector((state) => state.user.paths);
  const [courseContent, setCourseContent] = useState([]);
  const [announcement, setAnnouncement] = useState([]);
  const [totalVideoHours, setTotalVideoHours] = useState([]);
  const [sections, setSections] = useState([]);
  const [lectures, setLectures] = useState([]);
  const [progressReport, setProgressReport] = useState([]);
  const [hasCertificate, setHasCertificate] = useState([]);
  const [showEmptyItemBlock, setShowEmptyItemBlock] = useState(false);
  const [renewalCourseNotify, setRenewalCourseNotify] = useState(false);
  const [toastVariant, setToastVariant] =  useState('primary');
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isValidMember, setIsValidMember] = useState(false);
  const [renewalCourseData, setRenewalCourseData] = useState({});
  const [renewalPrice, setRenewalPrice] = useState(0);
  const [renewalButtonText, setRenewalButtonText] = useState('');
  const [toastRenewalSuccessMessage, setToastRenewalSuccessMessage] = useState(false);
  const [toastRenewalErrorMessage, setToastRenewalErrorMessage] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [isRatingChanged, setIsRatingChanged] = useState(false);
  const [showQA, setShowQA] = useState(false);

  /* ACCESS CHECK */
  const products  = adminData.products;
  const userSpEnabled = adminData?.user_sp_enabled;
  const [noAccess, setNoAccess] = useState(checkDisabledSp('mykademy', products, userSpEnabled));

  const { slug } = useParams();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(window.location.search);
  const renewParam = queryParams.get('renew') || null;
  const bundleParam = queryParams.get('bundle_id') || null;

  const fetchContents = async (params) => {
    try {
      const payload = {
        accessToken: configData.access_token,
        slug: params
      }
      if (payload.slug == '') {
        setHasError(true);
        return;
      }
      const allEnrolledCourses = await getEnrolledContents(payload);
      setIsLoading(false);
      if (allEnrolledCourses) {
        return allEnrolledCourses;
      } else {
        setHasError(true);
      }
    } catch (error) {
      setIsLoading(false);
      setHasError(true);
      console.error(error);
    } 
  };

  const getRenewalTransferredCourseDetail = async (renewalSetting, renewable) => {
    const courseId = renewalSetting?.course_options?.course_id;
    if (!courseId) return;

    const payload = {
      accessToken: configData.access_token,
      courseId
    };

    try {
      const courseData = await getCourse(payload);
      if (courseData.subscription_details?.cs_percentage == 0) {
        renewable = true;
      }
      return {courseData, renewable};
    } catch (err) {
      console.error(err);
    }
  };

  const checkValidMembership = async (courseContent, anotherCourse) => {
    const memberStatus = anotherCourse?.cb_member_status || courseContent?.cb_member_status;
    const postParams = { member_status: memberStatus };

    try {
      const membershipValid = await validMember(configData.access_token, postParams);
      return membershipValid;
    } catch (err) {
      console.error(err);
    }
  };

  const checkRenewalEligibility = async (courseContent, anotherCourse, renewable) => {
    const newCourseId = anotherCourse?.cb_id || courseContent?.cs_course_id;
    const postParams = {
      course_id: courseContent?.cs_course_id,
      new_course_id: newCourseId
    };

    try {
      const renewalData = await renewalEligibility(configData.access_token, postParams);
      if (renewalData.data.is_eligible != false) {
        renewable = true;
        if(courseContent?.cs_event_id !== undefined) {
          renewable = courseContent?.cs_event_id > 0 ? false : true;
        } 

        //check cookie exists
        const userId = learnerData.logged_in_user.user.id;
        const cookieName = `renewal_${courseContent?.cs_course_id}_${userId}`;
        const renewalCookie = document.cookie.split('; ').find(row => row.startsWith(cookieName)) ? document.cookie.split('; ').find(row => row.startsWith(cookieName)).split('=')[1] : null;
        const renewedData = renewalCookie ? JSON.parse(renewalCookie) : [];

        if (renewedData && Array.isArray(renewedData) && renewedData.length > 0) {
          renewable=false;
        }

        return renewable;
      } else {
        renewable = false;
        return renewable;
      }
    } catch (err) {
      console.error(err);
    }
  };

  const checkRenewalSetting = async (courseContent) => {
    let renewable = false;
    let membershipValid = 0;
    if (courseContent?.cb_is_renewal_enabled == 1) {
      const renewalSetting = courseContent?.cb_renewal_setting ? JSON.parse(courseContent.cb_renewal_setting) : null;
      if (renewalSetting) {
        let anotherCourse = {};
        if (renewalSetting?.course_options?.same_course == 0) {
          const courseDetails = await getRenewalTransferredCourseDetail(renewalSetting, renewable);
          anotherCourse = courseDetails.courseData;
          renewable = courseDetails.renewable;
        }
        
        membershipValid = await checkValidMembership(courseContent, anotherCourse);
        renewable = await checkRenewalEligibility(courseContent, anotherCourse, renewable);

        if(renewable) {
          let finalPrice = 0;
          if(renewalSetting?.pricing_options?.option != "1") {
            let price = "Free";
            const selectedCourse = (Object.keys(anotherCourse).length > 0) ? anotherCourse : courseContent;

            if (selectedCourse.cb_is_free == 1 && renewalSetting?.pricing_options?.option != "2") {
              price = "Free";
            } else {
              price = (membershipValid == 1) ? Number(selectedCourse.cb_member_price) : (selectedCourse.cb_discount > 0) ? selectedCourse.cb_discount : selectedCourse.cb_price;
            }

            const taxMethod = (Object.keys(anotherCourse).length > 0) ? anotherCourse.cb_tax_method : courseContent.cb_tax_method;

            if (taxMethod == 1 && price != "Free") 
            { // excluding tax
              finalPrice = price + (price * configData.global_tax_percentage / 100);
            }

            // Price Format function
            function priceFormat(value, addMinus = false) {
                addMinus = addMinus ? '- ' : '';
                if (parseFloat(value) !== 0) {
                    return addMinus + parseFloat(value).toFixed(2);
                } else {
                    return value;
                }
            }

            switch (renewalSetting?.pricing_options?.option)
            {
              case "2":
                if (taxMethod == 1 && price != "Free") {
                  setRenewalPrice(priceFormat(Number(renewalSetting?.pricing_options?.renewal_fee) + Number((renewalSetting?.pricing_options?.renewal_fee * configData.global_tax_percentage / 100))));
                } else {
                  setRenewalPrice(priceFormat(Number(renewalSetting?.pricing_options?.renewal_fee)));
                }
                break;
              case "3":
                const basePrice = (finalPrice == 0) ? price : finalPrice;
                setRenewalPrice((basePrice != "Free") ? priceFormat(basePrice - (basePrice * renewalSetting?.pricing_options?.offer_discount / 100)) : 0);
                break; 
              case "4":
                setRenewalPrice((finalPrice == 0 && price === "Free") ? 0 : priceFormat((finalPrice == 0) ? price : finalPrice));
                break;                                                         
            }
          }      
          finalPrice > 0 ? setRenewalButtonText('Pay Now') : setRenewalButtonText('Enroll');
        }

        if(renewalSetting?.enrollment_options?.option == 2 || renewalSetting?.enrollment_options?.option == 4) {
          setRenewalCourseNotify(renewable);
        } else {
          setRenewalCourseNotify(false);
        }
        setRenewalCourseData(anotherCourse);
      }
    }
  };

  const handleCheckout = async () => {
    
    const postParams = {
      course_id: courseContent?.cs_course_id,
      is_free: renewalPrice == 0 ? true : false,
      renewal_price: renewalPrice
    };

    try {
      const response = await renewalCheckout(configData.access_token, postParams);

      if(response.status == 200) {
        if(response?.data?.free_renewal == true) {
          setToastRenewalSuccessMessage(true);
          setRenewalCourseNotify(false);
        } else {
          const paymentId = response?.data?.payment_id; 
          if(paymentId) {
            const prevUrl =  window.location.origin + '/student-dashoard/courses/detail/' + courseContent?.cb_slug;
            const redirectUrl = window.location.origin + '/checkout/payment_request/' + Buffer.from(String(paymentId)).toString('base64') + '/' + Buffer.from(prevUrl, 'utf-8').toString('base64');
            window.location.href = redirectUrl;
          }
        }
      }
    } catch(err) {
      console.log(err);
    }
  }

  const asRatingUpdate = () => {
    setIsRatingChanged((prev) => !prev);
  }

  useEffect(() => {
    setShowEmptyItemBlock(false);
    const loadData = async () => {
      const data = await fetchContents(slug);
      if (data) {
        setCourseContent(data.data);
        checkRenewalSetting(data.data);
        setAnnouncement(data.data.announcements);
        setSections(data.data.sections);
        setLectures(data.data.lectures);
        setTotalVideoHours(hourSplit(data.data.cb_total_video_hours));
        setHasCertificate(data.data?.cb_has_certificate ?? 0);
        setShowEmptyItemBlock(true);
      } else {
        setHasError(true);
      }
    }
    loadData();
  }, [slug, isRatingChanged]);

  useEffect(() => {
    if (renewParam !== null && renewParam === '0') {
      setToastRenewalErrorMessage(true);
    } else if(renewParam !== null && renewParam === '1') {
      setToastRenewalSuccessMessage(true);
    }
  }, [renewParam]);
  
  const coursePages = [
    { icon: homeIcon, label: "Home", url: "/student-dashboard/" },
    { icon: coursesIcon, label: "Courses", url: "/student-dashboard/courses" },
    { label: courseContent?.cb_title }
  ];

  const toggleDescription = () => {
    setIsExpanded(!isExpanded);
  };

  const hourSplit = (param) => {
    if (param === '0') return 0;
    const combination  = param.split('-');
    if (combination[0] === '0') return 0;
    
    if (combination[1] === 'hours') {
      return pluralize(parseInt(combination[0]), 'hour', true);
    } else {
      // minutes
      const minutes = parseInt(combination[0]);
      if (minutes > 60) {
        return pluralize(Math.floor(minutes / 60), 'hour', true) + ' ' + pluralize(minutes % 60, 'minute', true);
      } else {
        return pluralize(minutes, 'minute', true);
      }
    }
  }

  const courseDate   = courseContent?.updated_date ?? courseContent?.created_date ?? '';
 const deadlineDate = courseContent?.cs_course_validity_status === '0' ? 'Lifetime Validity' : 
                      courseContent?.cs_end_date ? 'Deadline : ' + format(parseISO(courseContent?.cs_end_date), 'MMM d, yyyy') :
                      'Lifetime Validity';
  
  const courseOverviewData = {
    courseDescDetails: {
      title: courseContent?.cb_title,
      description: courseContent.cb_description ? courseContent.cb_description : '',
      descriptionLength: courseContent.cb_description ? (courseContent.cb_description.replace(/<[^>]+>/g, "")).length : 0,
      backIcon: leftArrowLong,
    },
    instructorDetails: courseContent.tutors,
    objectives: courseContent.cb_what_u_get ? JSON.parse(courseContent.cb_what_u_get) : [],
    courseDetails: [
      { show: true, icon: bookhalfIcon, label: pluralize(courseContent.lecture_count, 'Lecture', false), value: courseContent.lecture_count },
      { show: true, icon: calendarsIcon, label: '', value: deadlineDate },
      { show: true, icon: emplyArrow, label: '', value: courseContent?.category ?? 'N/A' }, 
      { show: hasCertificate == '1' ? true : false, icon: certiIcon, label: "Certificate of completion" },
      { show: true, icon: clockIcon, label: "Total Duration", value: totalVideoHours }
    ]
  };
  
  const lectureData = sections.map((section) => {
    const relatedLectures = lectures
      .filter((lecture) => lecture.cl_section_id === section.id)
      .map((lecture) => ({
        courseId: section.s_course_id,
        lectureId: lecture.cl_id,
        title: lecture.cl_lecture_name,
        showAttempts: lecture.cl_lecture_type !== 3 ? 'disable' : 'enable',
        showProgressBar: lecture.cl_lecture_type !== 4 ? 'disable' : 'enable',
        progressPercentage: lecture.cl_lecture_type !== 4 ? 0 : lecture.ll_percentage,
        attempts: lecture.ll_attempt,
        showDuration: (lecture.a_duration === null && lecture.cl_duration == 0) ? 'disable' : 'enable',
        duration: (lecture.a_duration !== null) ? lecture.a_duration : Math.floor((lecture.cl_duration/60) * 100)/100,
        status: parseInt(lecture.ll_percentage) === 100 ? 'completed' : (parseInt(lecture.ll_percentage) > 0 && parseInt(lecture.ll_percentage) < 100) ? 'inprogress' : 'notStarted',
        subTopics: [],
      }))
    
    const totalDuration = relatedLectures.reduce((sum, lecture) => sum + (lecture.duration || 0), 0);
    const overallStatus = relatedLectures.some(lecture => lecture.status === 'notStarted');
    return {
      title: section.s_name,
      // attempts: 0,
      duration: totalDuration,
      status: overallStatus ? 'notStarted' : 'completed',
      subTopics: relatedLectures,
    };
  });  

  const continueCourseLearning = (itemId, subItemId = 0, isCertificate = false) => {
    const url  = courseMaterialUrl(itemId, subItemId, `student-dashboard/courses/detail/${slug}` + (bundleParam !== null ? `?bundle_id=${bundleParam}` : '' ), isCertificate);
    window.location.replace(url);
  }

  const onRetryClick = (lecture, event) => {
    event.preventDefault();
    continueCourseLearning(lecture.courseId, lecture.lectureId);
  };

  const onStartClick = (lecture, prevStatus, event) => {
    event.preventDefault();
    let lectureId = 0;
    if (prevStatus > 0) {
      lectureId = lecture.lectureId
    }
    continueCourseLearning(lecture.courseId, lectureId);
  };

  const onContinueClick = (lecture, event) => {
    event.preventDefault();
    continueCourseLearning(lecture.courseId, lecture.lectureId);
  };

  const onGenerateCertificateClick = () => {
    continueCourseLearning(courseContent.cs_course_id, courseContent?.cb_certificate, true);
  };

  const areAllSubTopicsCompleted = (subTopics) => {
    if (!subTopics || subTopics.length === 0) return true;
    return subTopics.every(subTopic => subTopic.status === 'completed');
  };
  
  const updateLectureStatus = (lecture) => {
    if (areAllSubTopicsCompleted(lecture.subTopics)) {
      return { ...lecture, status: 'completed' };
    }
    return lecture;
  };
  
  const updateAllLecturesStatus = (lectures) => lectures.map(updateLectureStatus);
  
  const updatedLectures = updateAllLecturesStatus(lectureData);

  const handleReportClick = async (e) => {
    e.preventDefault();
    setShowQA(false);
    try {
      const payload = {
        courseId : courseContent?.cs_course_id ?? 0,
        userId: configData?.session?.id ?? 0
      }
      if (payload.courseId === 0 || payload.userId === 0) {
        return false;
      }
      const subjectReport = await getEnrolledSubjectReport(configData.access_token, payload);
      if (subjectReport.status === 200) {
        setProgressReport(subjectReport.data);
      }
    } catch (error) {
      console.error(error);
    } 
  }
  
  const CoursesProgress = progressReport && progressReport.length > 0 && progressReport?.map((report) => {
    return {
      name: report.name,
      progress: report.percentage
    }
  });

  const announcements = announcement && announcement.map((announcement) => {
    return {
      id: announcement.an_id,
      title: announcement.an_title,
      posterName: announcement.us_name,
      date: formatDaysAgo(announcement.an_date),
      description: announcement.an_description,
      descriptionLength: announcement.an_description ? (announcement.an_description.replace(/<[^>]+>/g, "")).length : 0,
      imageSrc: imageSrc('user', announcement.us_image, paths)
    }
  });

  const handleFullScreenClick = () => {
      const body = document.body;

      if (isFullScreen) {
        body.classList.remove('myk__stu-video-fullscreen');
      } else {
        body.classList.add('myk__stu-video-fullscreen');
      }

      setIsFullScreen(!isFullScreen);
  };

  const handleBackClick = () => {
    navigate('/courses');
  };

  const handlePlayCourse = () => {
    continueCourseLearning(courseContent?.cs_course_id, 0, false);
  }

  const maxChars = 500;
  const displayDesc = isExpanded && courseOverviewData.courseDescDetails.description !== ''
    ? courseOverviewData.courseDescDetails.description
    : courseOverviewData.courseDescDetails.descriptionLength > 500 ? `${courseOverviewData.courseDescDetails.description.substring(0, maxChars)}...` : courseOverviewData.courseDescDetails.description;

  
  const calculateAverageRating = (data) => {
    if (!data) return 0;
    const totalReviews = data ? data.length : 0;
    const totalRating  = data ? data.reduce((acc, item) => acc + item.rating, 0) : 0;
    return totalReviews > 0 ? totalRating : 0;
  };
  
  const handleQaClick = (e) => {
    e.preventDefault();
    setShowQA(true);
  }

  const handleDisableQA = (e) => {
    e.preventDefault();
    setShowQA(false);
  }

  return (
    <>
    {noAccess ? <Error403 /> : 
     hasError ? (<Error404 className="errow-with-nav"/>) : (
      <>
      <BreadCrumbs pages={coursePages} />
      <div className="myk__stu-guide-course-title">
        <span onClick={handleBackClick}>{leftArrowLong}</span>
        <h2>{courseContent?.cb_title}</h2>
      </div>
      <div className={`${className || ""} myk__stu-courses-wrapper myk__stu-courses_details-wrapper`}>
        <Row>
          <Col md={{ span:12, order: 0 }} lg={{ span:12, order: 0 }} xl={{ span:8, order: 0 }} className="myk__course-details-col">
              <IntroCard
                  id={courseContent?.cs_course_id}
                  imgSrc={imageSrc('course',courseContent?.cb_image, paths)}
                  subTitle={courseContent?.cb_title}
                  initialRating="3"
                  progressPercentage={courseContent?.cs_percentage}
                  showRating={courseContent?.cb_has_rating === '1' ? true : false}
                  isSelfRated={courseContent?.course_reviews?.self_review !== null ? true : false}
                  validityAccessType={courseContent?.cs_course_validity_status ?? ''}
                  validityByDays={courseContent?.cb_validity ?? ''}
                  validityByDate={courseContent?.cb_validity_date ?? ''}
                  courseDate={courseContent?.cs_end_date ?? ''}
                  isLoading={isLoading}
                  render={true}
                  isCourse={true}
                  asRatingUpdate={asRatingUpdate}
                  overallRating={courseContent?.overall_rating ? calculateAverageRating(courseContent?.overall_rating) : 0}
                  reviews={courseContent?.course_reviews ?? ''}
                  onPlayBtnClick={handlePlayCourse}
                  isBundle={courseContent?.cs_is_bundle !== '0' ? true : false}
              />
              
              <div style={{ display: toastRenewalSuccessMessage ? "block" : "none" }}>
                <Toast variant="primary" className="mb-2 mt-2">
                  <Toast.Body>
                    <ToastInfo toastDescription="Course Renewal Process Completed Successfully" />
                    <div className="action-wrapper">
                      <Button
                        variant="primary"
                        type="button"
                        size="sm"
                        className="btn-round bg-primary-fade"
                        aria-label="Close"
                        onClick={() => {
                          setToastRenewalSuccessMessage(false) 
                          const newQueryParams = new URLSearchParams(window.location.search);
                          newQueryParams.delete('renew');
                          window.history.replaceState({}, document.title, `${window.location.pathname}?${newQueryParams}`);
                          }}
                      >
                        Close
                      </Button>
                    </div>
                  </Toast.Body>
                </Toast>
              </div>

              <div style={{ display: toastRenewalErrorMessage ? "block" : "none" }}>
                <Toast variant="error" className="mb-2 mt-4">
                  <Toast.Body>
                  <ToastInfo toastDescription="Something went wrong while course Renewal Process" />
                  <div className="action-wrapper">
                      <Button
                      variant="error"
                      type="button"
                      size="sm"
                      className="btn-round bg-orange-fade text-white"
                      aria-label="Close"
                      onClick={() => {
                        setToastRenewalErrorMessage(false)
                        const newQueryParams = new URLSearchParams(window.location.search);
                          newQueryParams.delete('renew');
                          window.history.replaceState({}, document.title, `${window.location.pathname}?${newQueryParams}`);
                      }}
                      >
                      Close
                      </Button>
                  </div>
                  </Toast.Body>
                </Toast>
              </div>

              {renewalCourseNotify &&
              <Toast variant="error" className="w-100 myk__stu-c_renewal-notify">
                <Toast.Body>
                  <div className="myk_stu-c_renewal-content">
                    <h1><strong>Course Renewal Notification!</strong> <small>(Course expired! Please, renew enrollment.)</small></h1>
                    {
                      Object.keys(renewalCourseData).length > 0 ? 
                    <ToastInfo toastDescription={`After renewal you will transfer to ${renewalCourseData.cb_title}`} /> :
                    <ToastInfo toastDescription="After renewal you will enroll to same course" />
                    }
                  </div>
                  <div className="myk__stu-c_renewal_end-content">
                    <p><strong>Renewal Price: {miscellaneous.current_currency.symbol}{renewalPrice}</strong></p>
                    <div className="action-wrapper justify-content-end">
                      <Button variant="orange" type="button" size="sm" onClick={handleCheckout} className="btn-round">{renewalButtonText}</Button>
                    </div>
                  </div>
                </Toast.Body>
              </Toast>
              }
              {isLoading === false ? (
              <div className="myk__stu-course-tabs_wrapper">
                <Tab.Container id="myk__stu-course-highlights" defaultActiveKey="stu_overview">
                  <Row>
                    <Col sm={12}>
                      <Nav variant="pills" className="mb-3">
                        <Nav.Item>
                          <Nav.Link eventKey="stu_overview" onClick={(e) => handleDisableQA(e)}>Overview</Nav.Link>
                        </Nav.Item>
                        { configData?.discussionFormEnable === '1' && (
                        <Nav.Item>
                          <Nav.Link eventKey="stu_qa" onClick={(e) => handleQaClick(e)}>Q&A</Nav.Link>
                        </Nav.Item>
                        )}
                        <Nav.Item>
                          <Nav.Link eventKey="stu_report" onClick={(e) => handleReportClick(e)}>Reports</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="stu_test" onClick={(e) => handleDisableQA(e)}>Test overview</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="stu_announcement" onClick={(e) => handleDisableQA(e)}>Announcements</Nav.Link>
                        </Nav.Item>
                      </Nav>
                      <Tab.Content className="w-100">
                        <Tab.Pane eventKey="stu_overview" className="myk__stu-course-tab_content">
                          <div className="myk__stu-details-overview">
                          <Row>
                            <Col xl="8">
                              <div className="myk__stu-course-overview pe-lg-5">
                                <div className="myk__stu-course-about">
                                  <h2>About the Course</h2> 
                                  <div dangerouslySetInnerHTML={{ __html: displayDesc }} />
                                  {courseOverviewData.courseDescDetails.descriptionLength > 500 && 
                                  <span className="btn btn-transparent mt-3 p-0" onClick={toggleDescription}>{isExpanded ? "Show Less" : "Read More"}</span>
                                  }
                                  {courseOverviewData.objectives && 
                                  <div className="myk_stu-course-obj">
                                    <h2>Course Objectives:</h2>
                                    <ul>
                                      {courseOverviewData.objectives.map((obj, index) => (
                                        <li key={index}>{obj}</li>
                                      ))}
                                    </ul>
                                  </div>
                                  }
                                </div>
                              </div>
                            </Col>
                            <Col xl="4">
                            <div className="myk__stu-instructor-wrapper px-0 px-xxl-4">
                              {courseOverviewData.instructorDetails?.length > 0 && (
                                <>
                                <h2>Instructor</h2>
                                <div class="myk__stu-presenter-list"> 
                                  {courseOverviewData.instructorDetails && courseOverviewData.instructorDetails.map((tutor) => (
                                  <div className="information-block bg-information-white p-0">
                                    <div className="information-wrap">
                                      <div key={tutor.u_id} className="information-holder align-items-center gap-2 myk__stu-profile-wrapper">
                                        <div className="circle-wrap circle-wrap-md bg-circle-twilight text-white">
                                          <img src={imageSrc('user',tutor.us_image, paths)} />
                                        </div>
                                        <div className="information-detail">
                                          <h3>{tutor.us_name}</h3>
                                          <p>{tutor.us_email}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  ))} 
                                </div>
                                </>
                              )}
                                <div className="myk__stu-course-info">
                                  <h2>Course information</h2>
                                  <ul>
                                    {courseOverviewData.courseDetails
                                      .filter(item => item.value !== 0 && item.show)
                                      .map((item, index) => (
                                      <li key={index}>
                                        {item.icon} <span>{item.value ? <><strong>{item.value}</strong> {item.label}</> : item.label}</span>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                            </div>
                            </Col>
                          </Row>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="stu_qa">
                          <CourseQandA
                            courseId={courseContent.cs_course_id}
                            showQA={showQA}
                          />
                        </Tab.Pane>
                        <Tab.Pane eventKey="stu_report">
                          <CourseReport
                            courses={CoursesProgress}
                          />
                        </Tab.Pane>
                        <Tab.Pane eventKey="stu_test">
                          <TestJourney sections={sections} lectures={lectures} slug={slug} />
                        </Tab.Pane>
                        <Tab.Pane eventKey="stu_announcement">
                          <CourseAnnouncements announcements={announcements} />
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </div>
              ) : (
              <CourseContentLoader />
              )}
          </Col>
          <Col md={{ span:12, order: 0 }} lg={{ span:12, order: 0 }} xl={{ span:4, order: 0 }} className="myk__course-progress-col">
            {isLoading === false ? (
            <CourseProgressAccordion
              className="course-progress"
              lectures={lectureData}
              maxAttempts={3}
              enableSequentialProgress={courseContent?.cb_sequential == '1' ? true : false}
              onRetryClick={onRetryClick}
              onStartClick={onStartClick}
              onContinueClick={onContinueClick}
              hasCertificate={hasCertificate}
              onGenerateCertificateClick={onGenerateCertificateClick}
              lectureCount={courseContent?.lecture_count ?? '0'}
              isCertificateGenerated={courseContent?.cs_certificate_issued === '1' ? true : false}
            />
            ) : (
            <CourseCurriculumLoader items={2} />
            )}
          </Col>
        </Row>
      </div>
      <ToastContainer position="bottom-center" className="p-3 position-fixed zindex-high">
        <Toast variant={toastVariant} show={showToast} onClose={() => setShowToast(false)} delay={4500} autohide>
          <Toast.Body>
            <ToastInfo toastDescription={toastMessage} />
          </Toast.Body>
        </Toast>
      </ToastContainer>
      </>
    )}
    </>
  );
}

export default CourseDetails;

